import React from 'react';
import { FaTimes } from "react-icons/fa";
import Modal from "react-modal";
import Swal from 'sweetalert2';
import { ErrorMessage, Form, Formik } from "formik";
import * as Yup from "yup";
import MyTextArea from '../../../../../helpers/MyTextArea';
import { editMessageInNote } from '../../../../../helpers/Api';

const EditComment = ({
    modalIsOpen, 
    closeModal, 
    idSolicitud,
    idMessage, 
    data,
    query,
    setQuery,
    token,
}) => {

    const customStyles = {
        content: {
          top: "50%",
          left: "50%",
          width: "60%",
          height: "52%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          background: "linear-gradient(141.48deg, #DBFBFF -2.31%, #DBE9FF 101.54%)",
          borderRadius: "5px",
        },
      };

      let initialValues = {
        mensaje: data.mensaje,
      };


      const handlerEditMessage = async (values) => {
        try {
          const response = await editMessageInNote(
            idSolicitud,
            idMessage,
            token,
            values,
          );
          if (response) {
            setQuery(query + 1);
            closeModal();    
          }
        } catch (error) {
          Swal.fire("Oops", "Ha surgido un problema al postear mensaje", "error");
        } 
      };
      
  
    return (
        <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
    <div className="row m-1">
        <div className="col-12  d-flex flex-row-reverse">
          <button className="btn" onClick={closeModal}>
            <FaTimes style={{ color: "#F47777" }} />
          </button>
        </div>
      </div>
      <Formik
        enableReinitialize="true"
        initialValues={initialValues}
        validationSchema={Yup.object().shape({
        mensaje: Yup.string().required("Campo requerido"),
        })}
        onSubmit={(values, { resetForm, setSubmitting }) => {
        handlerEditMessage(values, setSubmitting);
        }}
          >
    {(props) => (
    <Form>
        <>
      <div className='row m-1'>
      <div className="col-12">
        <h6 className='mb-3'>Formulario para editar el comentario</h6>
        <label className="form-label">Comentario</label>
            <MyTextArea
            type="text-area"
            className="form-control"
            name="mensaje"
            rows="10"
            cols="50"
            />
        </div>
        <div className="col-12 mt-4 d-flex flex-row-reverse" style={{paddingRight: '20px'}}>
            <button  
            type='submit'
            className="btn btn-primary">
            Guardar cambios
            </button>
          </div>
      </div>
        </>
        </Form>
        )}
    </Formik>
    </Modal>
  
  )
}

export default EditComment